export default "__VITE_ASSET__Jy8gbSPq__"